import HeaderLayout from '../../../Layout/HeaderLayout';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IState, actions } from '../../../Store/reducer';
import { useEffect } from 'react';
import { redirectWithBoolean } from '../../../Components/RedirectPlayer/RedirectPlayer';
import { episodes } from '../../../Services/episodes';
import { TNbPlayers } from '../../../Models/TNbPlayers';
import { EPISODE_MASTER_PATH, INDEX_MASTER_PATH } from '../../../Services/routeNames';
import './configurationMaster.scss';

export default function ConfigurationMaster() {

    const { episodeNumber } = useSelector((state: IState) => state.master);
    const ARRAY_NUMBERS_PLAYERS: TNbPlayers[] = [2, 3, 4, 5, 6]

    const dispatch = useDispatch();
    const navigate = useNavigate();

    function setNumberPlayersAndRedirect(numberOfPlayers: TNbPlayers) {
        dispatch({
            type: actions.master.SET_NUMBER_PLAYERS,
            payload: {
                master: {
                    numberOfPlayers: numberOfPlayers,
                }
            },
        });

        navigate(INDEX_MASTER_PATH);
    }

    useEffect(() => {
        redirectWithBoolean(!episodeNumber || (episodeNumber > 5 && episodeNumber < 1) || !episodes[episodeNumber], EPISODE_MASTER_PATH, navigate);
    }, [navigate, episodeNumber]);

    return (
        <div className="players-number">
            <HeaderLayout currentPage="config" hamburger={true} isMaster={true}>
                <span>Nombre de joueurs</span>
            </HeaderLayout>

            {ARRAY_NUMBERS_PLAYERS.map((number, index: number) =>
                <div className="player-choice" key={index} onClick={() => setNumberPlayersAndRedirect(number)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 265.03 139"><g ><path fill="#fff" stroke="#e71d67" strokeMiterlimit="10" d="m264.13,127.57v-18.48h-.57v-5.54c0-.57-.32-1.08-.75-1.52l-.52-12.21-2.53.04-.68-19.43v-.19h-1.52c-.08-.3-.18-.58-.3-.84l-.4-22.7-31.38,3.31-20.6-2.49,50.15-3.18-.07-15.99h-.35V2.83c0-.7-.18-1.32-.43-1.88v-.45H125.39v.84S.51,1.34.51,1.34l.23,13.09v22.14l8.69-2.44h0s-8.43,5.41-8.43,5.41c0,.69.28,4.95.55,5.48l.32,14.63-.39,1.78.67,21.43.84.12.59,16.94,49.93.28-24.78,3.18-22.88.59.84,11.26h.57v21.31c0,.58.3,1.1.71,1.57v.37h256.53l-.38-10.93Z"/></g></svg>
                    <span>{number}</span>
                </div>
            )}
        </div>
    );
}
